export const DEFAULT_APP_STORE_URL =
  'https://apps.apple.com/us/app/joyajoy/id1530659435';

export const DEFAULT_TRY_CLASSROOMID =
  process.env.NODE_ENV === 'development'
    ? '08a9e109-d00a-48f0-aeeb-fc3e3b08942a'
    : '2535a644-a630-49f1-8b97-b20c2586f78d';

export const DEFAULT_DISTRIBUTORID =
  process.env.NODE_ENV === 'development'
    ? 'joyajoy-distributor'
    : 'joyajoy-distributor';

export const DEFAULT_PARTNERID =
  process.env.NODE_ENV === 'development'
    ? 'joyajoy-partner'
    : 'joyajoy-partner';

export const DEFAULT_SMART_PARENT_PLANID =
  process.env.NODE_ENV === 'development' ? 'web-plan' : 'web-plan';

export const DEFAULT_CREATION_TOKEN_OFFERID =
  process.env.NODE_ENV === 'development'
    ? '0e548169-066e-43dd-828f-24c67dfd7fc4'
    : 'd0a2c0a5-cc30-4313-9d8a-499347bf9d61';
